import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { InstructorCandidate } from '@/types';
import { KEYS } from './course-builder.keys';

// ── Instructors ──

export function useAddInstructor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      courseId,
      data,
    }: {
      courseId: number;
      data: { user_id: number; is_lead?: boolean };
    }) => api.post<void>(`/courses/${courseId}/instructors`, data),
    onSuccess: (_, v) => qc.invalidateQueries({ queryKey: KEYS.detail(v.courseId) }),
  });
}

export function useRemoveInstructor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ courseId, userId }: { courseId: number; userId: number }) =>
      api.delete<void>(`/courses/${courseId}/instructors/${userId}`),
    onSuccess: (_, v) => qc.invalidateQueries({ queryKey: KEYS.detail(v.courseId) }),
  });
}

export function useUpdateInstructorLead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      courseId,
      userId,
      isLead,
    }: {
      courseId: number;
      userId: number;
      isLead: boolean;
    }) => api.patch<void>(`/courses/${courseId}/instructors/${userId}`, { is_lead: isLead }),
    onSuccess: (_, v) => qc.invalidateQueries({ queryKey: KEYS.detail(v.courseId) }),
  });
}

export function useInstructorCandidates() {
  return useQuery({
    queryKey: KEYS.instructorCandidates,
    queryFn: () => api.get<InstructorCandidate[]>('/users/instructors'),
    select: (res) => res.data,
  });
}
